var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-status",class:_vm.compactClass},[_c('span',{staticClass:"template-status__icon",class:_vm.status,attrs:{"title":_vm.status}}),(!_vm.compact)?_c('span',{staticClass:"template-status__text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }